(() => {
	// Elements
	const comparebuttons = document.querySelectorAll('.po-block__action-btn--compare');
	const deletebuttons = document.querySelectorAll('.productcompare__action--delete');

	// Data
	const items = JSON.parse(localStorage.getItem('compare-products') || '[]');

	// Config names
	const activeBtnClass = 'po-block__action-btn--visible';

	// Functions
	const toggleClasses = prodid => {
		const elements = document.querySelectorAll(`.po-block__action-btn--compare[data-prodid="${prodid}"]`);
		elements.forEach(button => {
			if(button.classList.contains(activeBtnClass)) {
				button.classList.remove(activeBtnClass);
			} else {
				button.classList.add(activeBtnClass);
			}
		});
	};

	const addItem = e => {
		const el = e.target;
		const product = {
			id: el.dataset.prodid,
			img: el.dataset.imgsmall,
			name: el.dataset.prodname
		};
		window.EventBus.$emit('compare-product', product);
		toggleClasses(product.id);
	};

	const deleteItem = e => {
		let urlParams = new URLSearchParams(window.location.search);
		let groupParams = urlParams.get('compare').split(',');
		const prodid = e.target.dataset.prodid;

		window.EventBus.$emit('delete-compare-product', prodid);

		if(groupParams.includes(prodid)) {
			const newGroupParams = groupParams.filter(item => item !== prodid);
			urlParams.set('compare', newGroupParams.join(','));
			const url = window.location.pathname;
			const combinedUrl = `${url}?compare=${urlParams.get('compare')}`;
			window.location.href = combinedUrl;
		}
	};

	comparebuttons.forEach(btn => {
		btn.addEventListener('click', addItem);
		const prodid = btn.dataset.prodid;
		const isSelected = items.filter(p => p.id === prodid).length > 0;
		if(isSelected) {
			btn.classList.add(activeBtnClass);
		}
	});

	deletebuttons.forEach(btn => {
		btn.addEventListener('click', deleteItem);
	});


	// Equal height table
	const sameHeightRows = className => {
		var nodeList = [...document.querySelectorAll(`.${className}`)];
		var tallest = Math.max.apply(Math, nodeList.map(el => {
			el.style.minHeight = '';
			return el.offsetHeight;
		}));
		nodeList.forEach(el => { 
			el.style.minHeight = tallest + 'px';
		});
	};

	const rowLabels = document.querySelectorAll('.productcompare__headings li');
	rowLabels.forEach(label => {
		sameHeightRows(label.className);
	});
	
	window.addEventListener('resize', function() { 
		const rowLabels = document.querySelectorAll('.productcompare__headings li');
		rowLabels.forEach(label => {
			sameHeightRows(label.className);
		});
	});

})();